export default {
  mobile: 'موبایل',
  submit: 'تایید',
  pleaseTryAgain: 'لطفا مجددا تلاش کنید',
  view: 'مشاهده',
  delete: 'حذف',
  no: 'خیر',
  yes: 'بله',
  nothingFound: 'موردی یافت نشد!',
  nothingAdded: 'موردی اضافه نشده',
  pressEnterToSelect: 'برای انتخاب Enter را فشار دهید',
  pressEnterToRemove: 'برای حذف Enter را فشار دهید',
  selected: 'انتخاب شده',
  choose: 'انتخاب کنید',
  more: 'بیشتر',
  less: 'کمتر',
  start: 'شروع',
  resume: 'ادامه',
  infoOf_: 'اطلاعات {title}',
  address: 'آدرس',
  car: 'خودرو',
  row: 'ردیف',
  and: 'و',
  type: 'نوع',
  plateTemplate: '{right} {character} {left} - ایران {iran}',
  other: 'سایر',
  description: 'توضیحات',
  attachments: 'پیوست ها',
  attachment: 'پیوست',
  image: 'تصویر',
  cancel: 'لغو',
  save: 'ذخیره',
  back: 'بازگشت',
  creationTime: 'تاریخ ثبت',
  routeTo: 'مسیریابی به {destination}',
  callTo: 'تماس با {person}',
  undrestand: 'فهمیدم',
  price: 'قیمت',
  driverFeeAmount: 'کرایه راننده',
  farePerPoint: 'کرایه حمل',
  trash: 'نخاله',
  material: 'مصالح',
  toman: 'تومان',
  title: 'عنوان',
  count: 'تعداد',
  status: 'وضعیت',
  dateAndTime: 'تاریخ و ساعت',
  edit: 'ویرایش',
  filter: 'فیلتر',
  confirm: 'تایید',
  selectAll: 'انتخاب همه',
  courier: 'پروژه',
  startDate: 'تاریخ شروع',
  endDate: 'تاریخ پایان',
  open: 'بازکردن',
  fromStartToEnd: 'از ساعت {start} تا {end}',
  noAddress: 'بدون آدرس',
  noData: 'داده ای موجود نیست',
  skipDestination: 'تحویل ناموفق',
  accept: 'پذیرفتن'
}
